// extracted by mini-css-extract-plugin
export default {"wrapper":"a21C0","placeholderWrapper":"b21C0","placeholderHidden":"c21C0"};